import React, { Component, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Icon,
  Card,
  Input,
  Table,
  Button,
  message,
  Spin,
  Modal,
  Row,
  Col,
  Tooltip,
  DatePicker,
  Select,
  Checkbox,
} from "antd";
import F from "../../../../Functions";
import moment from "moment";
import { Translate, Translator } from "react-translated";
import axios from "axios";
import Pagination from "../../../../components/pagination";
import {
  AGENCY_MANAGER,
  AGENCYMANAGER,
  ALL_AGENCIES,
  ASC,
  DATE_FORMAT,
  DESC,
  EA,
  EXPORT_DATA,
  FOLLOWUP,
  LEAD,
  LSP,
  OPPORTUNITY,
  PROSPECT,
  REVIEW,
  SORT_ORDER_ASCEND,
  SORT_ORDER_DESCEND,
  SUPER_ADMIN,
} from "../../../../utils/Constants";
import EaAppointmentLogs from "./EaAppointmentLogs";
import { useBoundStore } from "../../../../store/useBoundStore";
import {
  GET_ALL_AGENCIES_BY_CARRIER_AND_ACTIVE,
  GET_AM_ASSOCIATED_AGENCIES,
  GET_AM_DASH_LEAD_APPOINTMENT_BTN_CLICK,
  GET_AM_DASH_OPPORTUNIY_BTN_CLICK,
  GET_AM_DASH_REVIEW_APPOINTMENT_BTN_CLICK,
  GET_GLOBAL_DASH_LEAD_APPOINTMENTS_SCHEDULED_GRID,
  GET_GLOBAL_DASH_OPPORTUNITY_APPOINTMENTS_SCHEDULED_GRID,
  GET_GLOBAL_DASH_REVIEW_APPOINTMENTS_SCHEDULED_GRID,
  GET_MY_ASSOCIATIONS,
} from "../../../../utils/Api_enums";
import "./vAA.css";
import CustomAgGridTable from "../../../../Common-Table/CustomAgGridTable";
import CustomHeader from "../../../../CommonHeader/CustomHeader";
import { attachRangePickerCloseButton } from "../../../../utils/rangePickerCloseButton";

// Add styles for the status dropdown
const statusDropdownStyles = {
  dropdownMenu: {
    maxHeight: "200px",
    overflowY: "auto",
    padding: "8px 0",
    backgroundColor: "#fff",
    borderRadius: "4px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
  },
  option: {
    padding: "8px 16px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    ":hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  checkbox: {
    marginRight: "8px",
  },
};

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const ButtonGroup = Button.Group;
// const dateFormat = "MM.DD.YYYY";
const dateFormat = DATE_FORMAT;
const userById = useBoundStore.getState().userById;
let agency_id =
  (userById &&
    userById.user_agency_assoc &&
    userById.user_agency_assoc[0] &&
    userById.user_agency_assoc[0].agency_id) ||
  null;

const Option = Select.Option;

export default class ViewAllAppointment extends Component {
  resetHandlers = [];

  //changed the state to IIFE
  state = (() => {
    //added due to new date picker implementation
    const defaultRange = F.getDefaultDateRange();
    const storedDates = localStorage.getItem("dateObj")
      ? JSON.parse(localStorage.getItem("dateObj"))
      : null;
    const globalDashboardFilter =
      useBoundStore.getState().GlobalDashboardFilter || {};
    const fSfilters = useBoundStore.getState().fSfilters || {};
    const globalDashboardDates = globalDashboardFilter.datemodified || {};
    const isSuperAdmin = this.props.user && this.props.user.user_type === SUPER_ADMIN;
    const gridSelectedCarriers =
      fSfilters.gridSelectedCarriers && fSfilters.gridSelectedCarriers.length > 0
        ? fSfilters.gridSelectedCarriers
        : (globalDashboardFilter.selectedCarriers || []);
    const gridSelectedAgencyState =
      fSfilters.gridSelectedAgencyState && fSfilters.gridSelectedAgencyState.length > 0
        ? fSfilters.gridSelectedAgencyState
        : (globalDashboardFilter.selectedAgencyState || []);
    const gridSelectedAgencies =
      fSfilters.gridSelectedAgencies && fSfilters.gridSelectedAgencies.length > 0
        ? fSfilters.gridSelectedAgencies
        : ((globalDashboardFilter.selectedAgencies &&
          globalDashboardFilter.selectedAgencies.length > 0)
          ? globalDashboardFilter.selectedAgencies
          : (globalDashboardFilter.agency_id ? [globalDashboardFilter.agency_id] : []));
    const selectedDateRange =
      this.props.isGlobalDashboard &&
        this.props.start_date &&
        this.props.end_date
        ? {
          start_date: moment(this.props.start_date).format("YYYY-MM-DD"),
          end_date: moment(this.props.end_date).format("YYYY-MM-DD"),
        }
        : isSuperAdmin &&
          globalDashboardDates.start_date &&
          globalDashboardDates.end_date
          ? {
            start_date: moment(globalDashboardDates.start_date).format("YYYY-MM-DD"),
            end_date: moment(globalDashboardDates.end_date).format("YYYY-MM-DD"),
          }
          : {
            start_date: storedDates
              ? storedDates.start_date
              : defaultRange.start_date,
            end_date: storedDates ? storedDates.end_date : defaultRange.end_date,
          };

    return {
      open: false,
      search: "",
      searchFilter: "",
      // filter_lsp: this.props.filter_lsp || "",
      user_t: localStorage.getItem("user_t") || "",
      //this.props.isFromAllViewAppointment ? this.props.user.id : localStorage.getItem("user_t") || "",
      user: this.props.user,
      bfiles: {
        Review: {
          data: [],
          page: 1,
          total_pages: 0,
        },
        FollowUp: {
          data: [],
          page: 1,
          total_pages: 0,
        },
        Prospect: {
          data: [],
          page: 1,
          total_pages: 0,
        },
      },
      rescheduleTarget: null,
      rescheduleNote: "",
      savingReschedule: false,
      rescheduleNoteSaved: false,
      isViewAppointmentLogs: false,
      loading: false,
      lsp: [],
      agencyStaffList: [],

      //commented due to new date picker implementation
      // start_date:
      //   (localStorage.getItem("dateObj") &&
      //     JSON.parse(localStorage.getItem("dateObj")).start_date) ||
      //   moment("01-01-2010").format("YYYY-MM-DD"),
      // end_date:
      //   (localStorage.getItem("dateObj") &&
      //     JSON.parse(localStorage.getItem("dateObj")).end_date) ||
      //   moment("01-01-2050").format("YYYY-MM-DD"),

      //added due to new date picker implementation
      start_date: selectedDateRange.start_date,
      end_date: selectedDateRange.end_date,

      period: null,
      stats_loading: true,
      // setup_appointment_modal: false,
      statusFilters: ["Complete", "Not Complete"],
      filteredInfo: [],
      expandStats: false,
      type_of_call: ["Review", "Prospect", "FollowUp"],
      type_of_call_selected: this.props.type_of_call || REVIEW,
      //type_of_call_selected: REVIEW,
      isFromAllViewAppointment: this.props.isFromAllViewAppointment || false,
      agencies: [],
      selectedAgency: useBoundStore.getState().AMDashboardFilter.agency_id,
      globalGridAgencies: [],
      globalGridFilteredAgencyResults: [],
      globalGridAgencyOptions: [],
      gridSelectedCarriers,
      gridSelectedAgencyState,
      gridSelectedAgencies,
    };
  })();

  apiMapAgencyManager = {
    Review: GET_AM_DASH_REVIEW_APPOINTMENT_BTN_CLICK,
    Prospect: GET_AM_DASH_LEAD_APPOINTMENT_BTN_CLICK,
    FollowUp: GET_AM_DASH_OPPORTUNIY_BTN_CLICK,
  };

  apiMapGlobalDashboard = {
    Review: GET_GLOBAL_DASH_REVIEW_APPOINTMENTS_SCHEDULED_GRID,
    Prospect: GET_GLOBAL_DASH_LEAD_APPOINTMENTS_SCHEDULED_GRID,
    FollowUp: GET_GLOBAL_DASH_OPPORTUNITY_APPOINTMENTS_SCHEDULED_GRID,
  };

  componentDidMount = () => {
    localStorage.setItem("vonboardEaDash", this.props.vonboard);
    localStorage.setItem("reviewEaDash", this.props.review);
    localStorage.setItem("leadEaDash", this.props.is_lead);
    localStorage.setItem("opportunityEaDash", this.props.is_opportunity);
    useBoundStore
      .getState()
      .setTypeOfCallSelectedEa({
        type_of_call_selected: this.props.type_of_call,
      });
    // let defaultSelection = "Prospect"; // Default to "Leads"

    // if (this.props.review === 1) {
    //   defaultSelection = "Review"; // If review is available, select "Review" first
    // }

    // this.setState({ type_of_call_selected: defaultSelection });
    this.setState({
      loading: true,
    });
    axios.get("/api/get_active_associations").then((res) => {
      let lsp = [];

      res.data.forEach((e) => {
        lsp.push({
          text: e.first_name + " " + e.last_name,
          value: e.first_name + " " + e.last_name,
          name: e.first_name + " " + e.last_name,
          id: e.id,
          user_type: e.user_type,
        });
      });

      this.setState({ agencyStaffList: lsp });
      this.setState({ lsp });
    });
    axios.get("/api/calendly/sync_events").then((res) => {
      this.setState({
        loading: false,
      });

      if (this.state.user.user_type == AGENCY_MANAGER) {
        this.fetchAssociatedAgencies();
      } else if (this.state.user.user_type === SUPER_ADMIN) {
        this.fetchGlobalGridAgencies();
      } else {
        this.loadConditionalData();
      }
    });
    // axios.get(GET_MY_ASSOCIATIONS).then((res) => {
    //   let agencyStaffList = []

    //   const dataObj = res.data

    //   const staffArray = Object.values(dataObj)[0] || []

    //   staffArray.forEach((u) => {
    //     agencyStaffList.push({
    //       name: u.first_name + " " + u.last_name,
    //       id: u.id,
    //       user_type: u.user_type,
    //     })
    //   })

    //   this.setState({ agencyStaffList })
    // })
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.isViewAppointmentLogs !== this.state.isViewAppointmentLogs) {
      this.loadConditionalData();
    }

    if (this.state.open && !prevState.open) {
      this._cleanupRangePickerCloseBtn = attachRangePickerCloseButton(() =>
        this.setState({ open: false })
      );
    } else if (!this.state.open && prevState.open && this._cleanupRangePickerCloseBtn) {
      this._cleanupRangePickerCloseBtn();
      this._cleanupRangePickerCloseBtn = null;
    }
  };

  componentWillUnmount = () => {
    if (this._cleanupRangePickerCloseBtn) {
      this._cleanupRangePickerCloseBtn();
      this._cleanupRangePickerCloseBtn = null;
    }
    if (this.state.user.user_type === SUPER_ADMIN) {
      useBoundStore.getState().setFsFilters({
        gridSelectedCarriers: [],
        gridSelectedAgencyState: [],
        gridSelectedAgencies: [],
        gridFilteredAgencyIds: [],
      });
    }
  };

  fetchAssociatedAgencies = async () => {
    try {
      const res = await axios.get(
        `${GET_AM_ASSOCIATED_AGENCIES}/${this.state.user.id}`,
      );
      if (res.data && res.data.length > 0) {
        const agencies = res.data;
        const oldestAgency = F.getOldestAgency(agencies);

        //const agency_id = res.data[0].agency_id;

        //commented due to new date picker implementation
        // this.setState({ agencies: res.data });
        // return agency_id;

        this.setState(
          {
            agencies,
            start_date: this.props.isGlobalDashboard
              ? this.state.start_date
              : oldestAgency.start_date
                ? moment(oldestAgency.start_date).format("YYYY-MM-DD")
                : "2010-01-01",
            end_date: this.props.isGlobalDashboard
              ? this.state.end_date
              : moment().format("YYYY-MM-DD"),
          },
          () => {
            this.loadConditionalData();
          },
        );
      }
    } catch (error) {
      console.error("Error fetching associated agencies:", error);
    }
    return null;
  };

  getGlobalDashboardAgencyIdsForAppointment = () => {
    const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
    const fS = useBoundStore.getState().fSfilters || {};
    const pageSelectedAgencies = fS.gridSelectedAgencies || [];
    const pageFilteredAgencyIds = fS.gridFilteredAgencyIds || [];
    const pageSelectedCarriers = fS.gridSelectedCarriers || [];
    const pageSelectedAgencyState = fS.gridSelectedAgencyState || [];
    const hasPageCarrierOrStateFilter =
      pageSelectedCarriers.length > 0 || pageSelectedAgencyState.length > 0;

    if (pageSelectedAgencies.length > 0) {
      return pageSelectedAgencies;
    }

    if (hasPageCarrierOrStateFilter) {
      return pageFilteredAgencyIds.length > 0 ? pageFilteredAgencyIds : [-1];
    }

    if (globalFilter.selectedAgencies && globalFilter.selectedAgencies.length > 0) {
      return globalFilter.selectedAgencies;
    }

    if (globalFilter.agency_id) {
      return [globalFilter.agency_id];
    }

    if (
      (globalFilter.selectedCarriers && globalFilter.selectedCarriers.length > 0) ||
      (globalFilter.selectedAgencyState && globalFilter.selectedAgencyState.length > 0)
    ) {
      return globalFilter.filteredAgencyIds && globalFilter.filteredAgencyIds.length > 0
        ? globalFilter.filteredAgencyIds
        : [-1];
    }

    return [];
  };

  getCarrierFilterValues = (selectedCarriers = this.state.gridSelectedCarriers) => {
    return selectedCarriers
      .map((selectedCarrier) => {
        const carrier = F.getCarriers().find((item) => item.id === selectedCarrier);
        return carrier ? carrier.name : selectedCarrier;
      })
      .filter((carrier) => carrier && carrier !== "All Carrier");
  };

  getLocallyFilteredGlobalAgencies = (
    agenciesList = this.state.globalGridAgencies,
    selectedCarriers = this.state.gridSelectedCarriers,
    selectedAgencyState = this.state.gridSelectedAgencyState,
  ) => {
    const carrierFilters = this.getCarrierFilterValues(selectedCarriers);
    const activeFilters = selectedAgencyState.map(String);

    return agenciesList.filter((agency) => {
      const carrierMatch =
        carrierFilters.length === 0 ||
        carrierFilters.includes(agency.agency_owner_carrier);
      const activeMatch =
        activeFilters.length === 0 ||
        activeFilters.includes(String(agency.active === 1));

      return carrierMatch && activeMatch;
    });
  };

  getInitialGlobalAgencyOptions = (
    agenciesList,
    selectedAgencies = this.state.gridSelectedAgencies,
  ) => {
    const selectedIds = new Set(selectedAgencies || []);
    const selectedAgencyOptions = agenciesList.filter((agency) =>
      selectedIds.has(agency.id),
    );
    const firstAgencies = agenciesList.slice(0, 100);
    const optionMap = new Map();

    [...selectedAgencyOptions, ...firstAgencies].forEach((agency) => {
      optionMap.set(agency.id, agency);
    });

    return Array.from(optionMap.values());
  };

  getGlobalAgencyDateRange = (selectedAgencyIds, agenciesList) => {
    const selectedIds = new Set(selectedAgencyIds || []);
    const selectedAgencyList = agenciesList.filter((agency) =>
      selectedIds.has(agency.id),
    );
    const oldestAgency = F.getOldestAgency(
      selectedAgencyList.length > 0 ? selectedAgencyList : agenciesList,
    );

    if (!oldestAgency) {
      return {
        start_date: "2010-01-01",
        end_date: moment().format("YYYY-MM-DD"),
      };
    }

    const startDate = moment(oldestAgency.start_date);
    const endDate = moment(oldestAgency.end_date || new Date());

    return {
      start_date: startDate.isValid()
        ? startDate.format("YYYY-MM-DD")
        : "2010-01-01",
      end_date: endDate.isValid()
        ? endDate.format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD"),
    };
  };

  applyGlobalGridAgencyFilters = ({
    selectedCarriers = this.state.gridSelectedCarriers,
    selectedAgencyState = this.state.gridSelectedAgencyState,
    selectedAgencies = this.state.gridSelectedAgencies,
    agenciesList = this.state.globalGridAgencies,
    shouldLoad = true,
  } = {}) => {
    const filteredAgencyResults = this.getLocallyFilteredGlobalAgencies(
      agenciesList,
      selectedCarriers,
      selectedAgencyState,
    );
    const validSelectedAgencies = (selectedAgencies || []).filter((agencyId) =>
      filteredAgencyResults.some((agency) => agency.id === agencyId),
    );
    const filteredAgencyIds = filteredAgencyResults
      .map((agency) => agency.id)
      .filter(Boolean);
    const hasCarrierOrStateFilter =
      selectedCarriers.length > 0 || selectedAgencyState.length > 0;
    const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
    const globalDates = globalFilter.datemodified || {};
    const hasNoPageGridFilters =
      selectedCarriers.length === 0 &&
      selectedAgencyState.length === 0 &&
      validSelectedAgencies.length === 0;
    const updatedDateRange = this.props.isGlobalDashboard
      ? {
        start_date: moment(this.state.start_date).format("YYYY-MM-DD"),
        end_date: moment(this.state.end_date).format("YYYY-MM-DD"),
      }
      : hasNoPageGridFilters && globalDates.start_date && globalDates.end_date
        ? {
          start_date: moment(globalDates.start_date).format("YYYY-MM-DD"),
          end_date: moment(globalDates.end_date).format("YYYY-MM-DD"),
        }
        : this.getGlobalAgencyDateRange(
          validSelectedAgencies,
          filteredAgencyResults,
        );

    useBoundStore.getState().setFsFilters({
      gridSelectedCarriers: selectedCarriers,
      gridSelectedAgencyState: selectedAgencyState,
      gridSelectedAgencies: validSelectedAgencies,
      gridFilteredAgencyIds: hasCarrierOrStateFilter
        ? (filteredAgencyIds.length > 0 ? filteredAgencyIds : [-1])
        : [],
      datemodified: updatedDateRange,
      page: 1,
    });

    this.setState(
      {
        globalGridFilteredAgencyResults: filteredAgencyResults,
        globalGridAgencyOptions: this.getInitialGlobalAgencyOptions(
          filteredAgencyResults,
          validSelectedAgencies,
        ),
        gridSelectedCarriers: selectedCarriers,
        gridSelectedAgencyState: selectedAgencyState,
        gridSelectedAgencies: validSelectedAgencies,
        start_date: updatedDateRange.start_date,
        end_date: updatedDateRange.end_date,
      },
      () => {
        if (shouldLoad) {
          this.loadConditionalData();
        }
      },
    );
  };

  fetchGlobalGridAgencies = async () => {
    const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
    const fS = useBoundStore.getState().fSfilters || {};
    const selectedCarriers =
      fS.gridSelectedCarriers && fS.gridSelectedCarriers.length > 0
        ? fS.gridSelectedCarriers
        : (globalFilter.selectedCarriers || []);
    const selectedAgencyState =
      fS.gridSelectedAgencyState && fS.gridSelectedAgencyState.length > 0
        ? fS.gridSelectedAgencyState
        : (globalFilter.selectedAgencyState || []);
    const selectedAgencies =
      fS.gridSelectedAgencies && fS.gridSelectedAgencies.length > 0
        ? fS.gridSelectedAgencies
        : ((globalFilter.selectedAgencies &&
          globalFilter.selectedAgencies.length > 0)
          ? globalFilter.selectedAgencies
          : (globalFilter.agency_id ? [globalFilter.agency_id] : []));

    try {
      const res = await axios.get(GET_ALL_AGENCIES_BY_CARRIER_AND_ACTIVE);
      const agenciesList = Array.isArray(res.data) ? res.data : [];

      this.setState({ globalGridAgencies: agenciesList }, () => {
        this.applyGlobalGridAgencyFilters({
          selectedCarriers,
          selectedAgencyState,
          selectedAgencies,
          agenciesList,
          shouldLoad: true,
        });
      });
    } catch (error) {
      console.error("Error fetching global grid agencies:", error);
      this.setState(
        {
          globalGridAgencies: [],
          globalGridFilteredAgencyResults: [],
          globalGridAgencyOptions: [],
        },
        () => this.loadConditionalData(),
      );
    }
  };

  loadConditionalData = () => {
    if (this.state.isFromAllViewAppointment) {
      this.state.type_of_call.forEach((e) => {
        this.loadBFiles(1, e);
      });
    } else {
      this.loadBFiles(1, this.state.type_of_call_selected);
    }
  };

  fetchDataForGlobalDashboard = async ({
    start_date = this.state.start_date,
    end_date = this.state.end_date,
    page = 1,
    type_of_call = this.state.type_of_call_selected,
    search = "",
    sort_by_name,
    filters,
    isExport = false,
  }) => {
    const api = this.apiMapGlobalDashboard[type_of_call];
    let parsedSort;

    if (!api) {
      this.setState({ loading: false });
      return;
    }

    if (sort_by_name) {
      parsedSort = JSON.parse(sort_by_name);
    }

    const defaultSortField = this.getAppointmentDateSortField(type_of_call);
    const sortField = parsedSort && parsedSort.field
      ? this.getAppointmentSortField(parsedSort.field, type_of_call)
      : defaultSortField;
    const sortDirection = parsedSort && parsedSort.direction
      ? parsedSort.direction
      : DESC;
    const status = filters || this.state.statusFilters || [];
    const decodedSearch = search ? decodeURIComponent(search).replace(/%/g, "") : "";
    const payload = {
      agency_ids: this.getGlobalDashboardAgencyIdsForAppointment(),
      start_date,
      end_date,
      page,
      sort: `${sortField}:${sortDirection}`,
      search: this.state.search || decodedSearch || "",
      completed: status.includes("Complete"),
      not_completed: status.includes("Not Complete"),
      filter_by_column_name: {},
      export: isExport ? "true" : "false",
    };

    try {
      const res = await axios.post(
        api,
        payload,
        isExport ? { responseType: "blob" } : undefined,
      );

      if (isExport) {
        if (res.data.type === "application/json") {
          message.error("No data found");
          return;
        }

        const blob = new Blob([res.data], {
          type: "text/csv;charset=utf-8;",
        });
        const fileName = `${F.transformCallTypeLabel(
          type_of_call,
        )}_Appointment_Report_${moment().format("YYYY-MM-DD")}.csv`;
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = downloadUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        return;
      }

      const responseData = res.data.data || [];
      const responsePage = res.data.page || page;
      const totalPages = res.data.total_pages || 0;

      this.setState((prevState) => ({
        loading: false,
        bfiles: {
          ...prevState.bfiles,
          [type_of_call]: {
            ...prevState.bfiles[type_of_call],
            data: responseData,
            page: responsePage,
            total_pages: totalPages,
          },
        },
      }));
    } catch (error) {
      console.error("Error fetching global appointment data:", error);
      message.error("Error fetching data");
    } finally {
      this.setState({ loading: false });
    }
  };

  fetchDataForAM = async ({
    start_date = "2010-01-01",
    end_date = "2050-01-01",
    page = 1,
    type_of_call = this.state.type_of_call_selected,
    agency_id,
    search = "",
    sort_by_name,
    filters,
    isExport = false,
  }) => {
    if (this.props.isGlobalDashboard) {
      start_date = moment(this.state.start_date).format("YYYY-MM-DD");
      end_date = moment(this.state.end_date).format("YYYY-MM-DD");
    }

    if (this.state.user.user_type === SUPER_ADMIN) {
      return this.fetchDataForGlobalDashboard({
        start_date,
        end_date,
        page,
        type_of_call,
        search,
        sort_by_name,
        filters,
        isExport,
      });
    }

    let sort;
    if (sort_by_name) {
      sort = JSON.parse(sort_by_name);
    }
    const api = this.apiMapAgencyManager[type_of_call];
    const params = {
      start_date,
      end_date,
      page,
    };

    let bfile_user_id = this.state.user_t;
    let agencyId = agency_id || this.state.selectedAgency;
    agencyId = agencyId === ALL_AGENCIES ? "" : agencyId;
    if (agencyId) params.agency_id = agencyId;
    if (search) params.search = decodeURIComponent(search);
    if (sort && sort.field && sort.direction) {
      params.sort = `${this.getAppointmentSortField(sort.field, type_of_call)}:${sort.direction}`;
    }
    if (bfile_user_id && bfile_user_id != "all") {
      params.bfile_user_id = bfile_user_id;
    }

    const status = filters || [];

    if (status.includes("Complete") && status.includes("Not Complete")) {
      params.completed = "true";
      params.not_completed = "true";
    } else if (status.includes("Complete")) {
      params.completed = "true";
    } else if (status.includes("Not Complete")) {
      params.not_completed = "true";
    }

    if (isExport) {
      params.export = true;
    }

    const queryString = new URLSearchParams(params).toString();
    const url = `${api}?${queryString}`;

    try {
      let res;
      if (isExport) {
        res = await axios.get(url, {
          responseType: "blob",
        });
      } else {
        res = await axios.get(url);
      }
      // res = await axios.get(url);

      //  EXPORT FLOW
      if (isExport) {
        if (res.data.type === "application/json") {
          message.error("No data found");
          return;
        }

        const blob = new Blob([res.data], {
          type: "text/csv;charset=utf-8;",
        });

        const fileName = `${F.transformCallTypeLabel(
          this.state.type_of_call_selected,
        )}_Appointment_Report_${moment().format("YYYY-MM-DD")}.csv`;

        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = downloadUrl;
        link.setAttribute("download", fileName);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(downloadUrl);

        return;
      }

      const page = res.data.page;
      const total_pages = res.data.total_pages;
      const responseData = res.data.data || [];

      this.setState((prevState) => ({
        loading: false,
        bfiles: {
          ...prevState.bfiles,
          [type_of_call]: {
            ...prevState.bfiles[type_of_call],
            data: responseData,
            page,
            total_pages,
          },
        },
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  // fetchDataForAM = async ({ start_date, end_date, page }) => {
  //   setLoading(true);
  //   let params = {};
  //   const filterStore = useBoundStore.getState().AMDashboardFilter;
  //   const filterStoreB = useBoundStore.getState().fSfilters;
  //   if (filterStore.datemodified.start_date) params.start_date = filterStore.datemodified.start_date;
  //   if (filterStore.datemodified.end_date) params.end_date = filterStore.datemodified.end_date;
  //   params.page = filterStore.page;
  //   params.type_of_call = getCallType(location);
  //   if (filterStore.agency_id) params.agency_id = filterStore.agency_id;
  //   if (filterStoreB.searchText) params.search = filterStoreB.searchText;

  //   if (filterStore.field && filterStore.direction) {
  //     params.sort = `${filterStore.field}:${filterStore.direction}`;
  //   }

  //   const queryString = new URLSearchParams(params).toString();
  //   const url = `${api}?${queryString}`;

  //   try {
  //     const res = await axios.get(url);

  //     if (res.data.data.length > 0) {
  //       if (gridApi) {
  //         gridApi.setRowData(res.data.data);
  //       }
  //       setTotalPages(res.data.total_pages);
  //       setRowData(res.data.data);
  //     } else {
  //       setRowData([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  loadBFiles(page, type_of_call, filters) {
    let { filteredInfo, searchFilter, start_date, end_date } = this.state;

    const { period } = this.props;

    this.setState({
      loading: true,
    });

    let from = null;
    let to = null;

    if (start_date != null && end_date != null) {
      from = start_date;
      to = end_date;
    } else if (period != null && period != "from_to") {
      const datesData = F.getServerDateByType(period);
      from = datesData.from;
      to = datesData.to;
    }

    from = `${from} 00:00:00`;
    to = `${to} 23:59:59`;
    let search;

    let direction = DESC;

    if (type_of_call === "Review") {
      if ("ea_review_sorting_direction" in window.localStorage) {
        direction = window.localStorage.ea_review_sorting_direction;
      }
    } else {
      if ("ea_virtual_sorting_direction" in window.localStorage) {
        direction = window.localStorage.ea_virtual_sorting_direction;
      }
    }

    let feild_name;
    if (type_of_call === "Review") {
      feild_name = "rs_appointment_date";
    } else {
      feild_name = "von_appointment_date";
    }

    const sort_by_name = JSON.stringify({
      field: feild_name,
      direction: direction,
    });

    if (searchFilter) {
      search = JSON.parse(searchFilter).or[0].val;
    }
    //for agency manager / owner / staff
    // if (this.props.user.user_type == AGENCY_MANAGER) {
    this.fetchDataForAM({
      start_date,
      end_date,
      page,
      type_of_call,
      search,
      sort_by_name,
      filters,
    });
    // }

    // else {
    //   axios.get("/api/user").then((res) => {
    //     const u = res.data;
    //     if (
    //       u.user_agency_assoc &&
    //       u.user_agency_assoc.length > 0
    //     ) {
    //       agency_id = u.user_agency_assoc[0].agency_id || null;
    //     }

    //     let filters = [];
    //     if (type_of_call === "Review") {

    //       filters = [
    //         { name: "agency_id", op: "==", val: agency_id },
    //         { name: "review", op: "==", val: "1" },
    //         { name: "rs_archived", op: "is_null" },
    //         { name: "is_saved_for_later", op: "==", val: "0" },
    //         { name: "deleted", op: "==", val: "0" },
    //         { name: "archive", op: "==", val: "0" },
    //         { name: "rs_action", op: "==", val: "1" },
    //         { name: "type_of_call", op: "==", val: type_of_call },
    //         {
    //           or: [
    //             { name: "reschedule_appointment", op: "eq", val: "0" },
    //             { name: "reschedule_appointment", op: "is_null" },

    //           ],
    //         },
    //         // { name: "reschedule_appointment", op: "==", val: "0" },

    //         // {
    //         //     "or": [
    //         //         {"name":"financial_id","op":"is_not_null"},
    //         //         {"name":"onboarding_id","op":"is_not_null"},
    //         //         {"name":"need_attention","op":"==","val":"1"},
    //         //     ]
    //         // }
    //       ];

    //     } else {
    //       filters = [
    //         // { name: "agency_id", op: "==", val: agency_id },
    //         // { name: "review", op: "==", val: "1" },
    //         // { name: "rs_archived", op: "is_null" },
    //         // { name: "is_saved_for_later", op: "==", val: "0" },
    //         // { name: "deleted", op: "==", val: "0" },
    //         // { name: "archive", op: "==", val: "0" },
    //         // { name: "rs_action", op: "==", val: "1" },
    //         {
    //           or: [
    //             {
    //               name: "reschedule_appointment_vo",
    //               op: "eq",
    //               val: "0",
    //             },
    //             {
    //               name: "reschedule_appointment_vo",
    //               op: "is_null",
    //             },
    //           ],
    //         },
    //         {
    //           name: "type_of_call",
    //           op: "==",
    //           val: type_of_call
    //         },

    //         // New Filter Added
    //         {
    //           name: "agency_id",
    //           op: "==",
    //           val: agency_id,
    //         },
    //         {
    //           name: "vob_completed",
    //           op: "==",
    //           val: "1",
    //         },
    //         {
    //           name: "vob_archived",
    //           op: "is_null",
    //         },
    //         // {
    //         //   name: "onboarding_id",
    //         //   op: "==",
    //         //   val: this.props.user.id,
    //         // },
    //         {
    //           name: "financial_id",
    //           op: "is_not_null",
    //         },
    //         {
    //           name: "deleted",
    //           op: "==",
    //           val: "0",
    //         },
    //         {
    //           or: [
    //             {
    //               name: "questions",
    //               op: "any",
    //               val: {
    //                 name: "financial_conversion_action",
    //                 op: "==",
    //                 val: "1",
    //               },
    //             },
    //             {
    //               name: "questions",
    //               op: "any",
    //               val: {
    //                 name: "financial_conversion_action",
    //                 op: "==",
    //                 val: "2",
    //               },
    //             },
    //           ],
    //         },
    //         // Adding this filter for avoiding von_appointment_date` --> null value
    //         {
    //           name: "von_appointment_date",
    //           op: "is_not_null",
    //         },
    //       ]
    //     }

    //     if (searchFilter !== "") filters.push(JSON.parse(searchFilter))

    //     if (filteredInfo.length === 1 && filteredInfo.includes("Complete")) {

    //       if (type_of_call === "Review") {
    //         filters.push({
    //           or: [
    //             { name: "need_attention", op: "==", val: 1 },
    //             { name: "onboarding_id", op: "is_not_null" },
    //             { name: "financial_id", op: "is_not_null" },
    //             { name: "is_onboarded", op: "==", val: 1 },
    //           ],
    //         });
    //       } else {
    //         filters.push({ name: "bfile_folow_up_completed", op: "==", val: "1" });
    //       }

    //     } else if (
    //       filteredInfo.length === 1 &&
    //       filteredInfo.includes("Not Complete")
    //     ) {

    //       if (type_of_call === "Review") {
    //         filters.push({
    //           and: [
    //             { name: "need_attention", op: "==", val: 0 },
    //             { name: "onboarding_id", op: "is_null" },
    //             { name: "financial_id", op: "is_null" },
    //             { name: "is_onboarded", op: "==", val: 0 },
    //           ],
    //         });
    //       } else {
    //         filters.push({
    //           or: [
    //             {
    //               name: "bfile_folow_up_completed",
    //               op: "is_null",
    //             },
    //             {
    //               name: "bfile_folow_up_completed",
    //               op: "==",
    //               val: "0",
    //             },
    //           ],
    //         });
    //       }
    //     }

    //     filters.push(
    //       { name: "rs_scheduled_date", op: ">=", val: `${from}` },
    //       { name: "rs_scheduled_date", op: "<=", val: `${to}` }
    //     );

    //     // if (type_of_call === "Review") {
    //     //   filters.push(
    //     //     { name: "rs_appointment_date", op: ">=", val: `${from} 00:00:00` },
    //     //     { name: "rs_appointment_date", op: "<=", val: `${to} 23:59:59` }
    //     //   );
    //     // } else {
    //     //   // New Filter Added
    //     //   // if (period !== "all_bfiles") {
    //     //   filters.push(
    //     //     {
    //     //       name: "vo_sent_date",
    //     //       op: ">=",
    //     //       val: from,
    //     //     },
    //     //     {
    //     //       name: "vo_sent_date",
    //     //       op: "<=",
    //     //       val: to,
    //     //     }
    //     //   );
    //     //   // }
    //     // }

    //     //for the appointments of staff
    //     if (this.state.user_t !== "") {
    //       filters.push({
    //         name: "user_id",
    //         op: "==",
    //         val: this.state.user_t,
    //       });
    //     }

    //     // new add
    //     F.getDncFilter(filters, false, true);

    //     filters = JSON.stringify(filters);

    //     let url = ""

    //     if (type_of_call === "Review") {
    //       url =
    //         "/api/b_file?page=" +
    //         page +
    //         '&q={"filters":' +
    //         filters +
    //         // ',"order_by":[{"field":"rs_appointment_date","direction":"desc"}]}';
    //         ',"order_by":[{"field":"rs_appointment_date","direction":' +
    //         `"${direction}"` +
    //         "}," +
    //         sort_by_name +
    //         "]}";
    //     } else {
    //       url =
    //         "/api/b_file?page=" +
    //         page +
    //         '&q={"filters":' +
    //         filters +
    //         // ',"order_by":[{"field":"rs_appointment_date","direction":"desc"}]}';
    //         ',"order_by":[{"field":"von_appointment_date","direction":' +
    //         `"${direction}"` +
    //         "}," +
    //         sort_by_name +
    //         "]}";
    //     }

    //     //for Agency Owner
    //     axios.get(url).then((res) => {
    //       const page = res.data.page;
    //       const total_pages = res.data.total_pages;

    //       F.log("URL=>", url);

    //       this.setState((prevState) => ({
    //         loading: false,
    //         bfiles: {
    //           ...prevState.bfiles,
    //           [type_of_call]: {
    //             ...prevState.bfiles[type_of_call],
    //             data: res.data.objects,
    //             page,
    //             total_pages
    //           }
    //         },
    //       }));
    //     });

    //   });
    // }
  }

  mark_as_complete = (bfile) => {
    const { type_of_call_selected } = this.state;
    let newObj = {};

    if (type_of_call_selected === "Review") {
      newObj["bfile_review_completed"] = 1;
    } else {
      newObj["bfile_folow_up_completed"] = "1";
    }
    axios.put(`/api/b_file/${bfile.id}`, newObj).then((e) => {
      axios.post("/api/bfile_notes", {
        bfile_id: bfile.id,
        note:
          "B File Marked as Complete - " + moment().format("MM/DD/YYYY hh:mmA"),
        user_id: this.state.user.id,
        action: "Mark as Complete",
      });
      this.loadBFiles(
        this.state.bfiles[this.state.type_of_call_selected].page,
        this.state.type_of_call_selected,
      );
    });
  };

  getAgencyId = () => {
    const userById = useBoundStore.getState().userById;
    return (
      (userById &&
        userById.user_agency_assoc &&
        userById.user_agency_assoc[0] &&
        userById.user_agency_assoc[0].agency_id) ||
      null
    );
  };

  rescheduleAppointment = (bfile) => {
    this.setState({
      rescheduleTarget: { bfile, type: this.state.type_of_call_selected },
      rescheduleNote: "",
      rescheduleNoteSaved: false,
    });
  };

  cancelReschedule = () => {
    if (this.state.savingReschedule) return;
    this.setState({ rescheduleTarget: null, rescheduleNote: "", rescheduleNoteSaved: false });
  };

  saveReschedule = async () => {
    const { rescheduleTarget, rescheduleNote, savingReschedule } = this.state;
    if (!rescheduleTarget || savingReschedule || !rescheduleNote.trim() || rescheduleNote.length > 250) return;

    const { bfile, type } = rescheduleTarget;
    this.setState({ savingReschedule: true });
    try {
      // Save the entered note before sending the file for rescheduling.
      // Preserve this step on retry if the subsequent update fails.
      if (!this.state.rescheduleNoteSaved) {
        await axios.post("/api/bfile_notes", {
          bfile_id: bfile.id,
          note: rescheduleNote,
          user_id: this.props.user.id,
          action: "Reschedule Appointment",
          notes_type: F.getNotesType(),
        });
        this.setState({ rescheduleNoteSaved: true });
      }
      await axios.put(`/api/b_file/${bfile.id}`, {
        ...(type === REVIEW
          ? { reschedule_appointment: 1 }
          : { reschedule_appointment_vo: 1 }),
        non_responsive: 0,
      });
    } catch (error) {
      this.setState({ savingReschedule: false });
      message.error(F.translate("Unable to reschedule the appointment. Please try again."));
      return;
    }

    this.setState((prevState) => ({
      savingReschedule: false,
      rescheduleTarget: null,
      rescheduleNote: "",
      rescheduleNoteSaved: false,
      bfiles: {
        ...prevState.bfiles,
        [type]: {
          ...prevState.bfiles[type],
          data: prevState.bfiles[type].data.filter((item) => item.id !== bfile.id),
        },
      },
    }));
    message.success(F.translate("Appointment sent for rescheduling."));

    try {
      const res = await axios.get(
        `/api/get_latest_appointment_history?agency_id=${this.getAgencyId()}&bfile_id=${bfile.id}&type_of_call=${type}`,
      );
      if (res && res.data && res.data.success) {
        await axios.put(`/api/appointment_history_details/${res.data.id}`, { reschedule: true });
      }
    } catch (error) {
      message.error(F.translate("The appointment was rescheduled, but its history could not be updated."));
    }
    if (this.props.refresh) this.props.refresh();
  };
  handleChange = (pagination, filters, sorter) => {
    this.setState({ filteredInfo: filters.status, loading: true }, () =>
      this.loadBFiles(1, this.state.type_of_call_selected, filters),
    );
  };

  clearFilters = () => {
    this.setState({ filteredInfo: [] });
  };

  updateExpandState = () => {
    this.setState((prevState) => ({
      expandStats: !prevState.expandStats,
    }));
  };

  onRangeChange = (dates) => {
    let start_date =
      dates && dates[0] ? moment(dates[0]).format("YYYY-MM-DD") : null;

    let end_date =
      dates && dates[1] ? moment(dates[1]).format("YYYY-MM-DD") : null;

    this.setState({ start_date, end_date }, () => {
      if (start_date && end_date) {
        this.loadConditionalData();
      }
    });
  };

  onChangeDate = (date, type) => {
    let { start_date, end_date, type_of_call } = this.state;

    date = (date && moment(date).format("YYYY-MM-DD")) || null;
    start_date =
      (start_date && moment(start_date).format("YYYY-MM-DD")) || null;
    end_date = (end_date && moment(end_date).format("YYYY-MM-DD")) || null;

    if (type === "start_date") start_date = date;
    if (type === "end_date") end_date = date;

    this.setState({ start_date, end_date }, () => {
      this.loadConditionalData();
    });
  };

  searchChange = (val) => {
    const searchPurify = F.removeSpecialCharactersFromString(val);
    let filters = "";
    if (searchPurify !== "") {
      const queries = [];
      // queries.push({
      //   name: "first_name",
      //   op: "like",
      //   val: encodeURIComponent("%" + searchPurify + "%")
      // });
      // queries.push({
      //   name: "last_name",
      //   op: "like",
      //   val: encodeURIComponent("%" + searchPurify + "%")
      // });
      // queries.push({
      //   name: "spouse_first_name",
      //   op: "like",
      //   val: encodeURIComponent("%" + searchPurify + "%")
      // });
      // queries.push({
      //   name: "spouse_last_name",
      //   op: "like",
      //   val: encodeURIComponent("%" + searchPurify + "%")
      // });
      queries.push({
        name: "email",
        op: "like",
        val: encodeURIComponent("%" + searchPurify + "%"),
      });
      queries.push({
        name: "phone",
        op: "like",
        val: encodeURIComponent("%" + searchPurify + "%"),
      });
      const search_arr = [...new Set(searchPurify.split(" "))];
      for (let x in search_arr) {
        if (x != "") {
          queries.push({
            name: "first_name",
            op: "like",
            val: encodeURIComponent("%" + search_arr[x] + "%"),
          });
          queries.push({
            name: "last_name",
            op: "like",
            val: encodeURIComponent("%" + search_arr[x] + "%"),
          });
          queries.push({
            name: "spouse_first_name",
            op: "like",
            val: encodeURIComponent("%" + search_arr[x] + "%"),
          });
          queries.push({
            name: "spouse_last_name",
            op: "like",
            val: encodeURIComponent("%" + search_arr[x] + "%"),
          });
        }
      }
      filters = '{"or":' + JSON.stringify(queries) + "}";
    }
    this.setState({ searchFilter: filters, search: val }, () => {
      this.loadBFiles(1, this.state.type_of_call_selected);
    });
  };

  // viewAppontmentHistory = () => {
  //   this.props.history.push({
  //     pathaname: `/appointment-history/${agency_id}`, state: { ...this.state }, props: { ...this.props }
  //   });
  // }

  refreshStats = () => {
    let start_date, end_date;
    const dateFilterAMDashbboard = useBoundStore.getState().AMDashboardFilter;
    const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};

    if (this.props.isGlobalDashboard) {
      start_date = moment(this.props.start_date).format("YYYY-MM-DD");
      end_date = moment(this.props.end_date).format("YYYY-MM-DD");
    } else if (this.state.user.user_type === SUPER_ADMIN) {
      const globalDates = globalFilter.datemodified || {};
      start_date = globalDates.start_date
        ? moment(globalDates.start_date).format("YYYY-MM-DD")
        : "2010-01-01";
      end_date = globalDates.end_date
        ? moment(globalDates.end_date).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
    } else if (this.state.user.user_type === AGENCY_MANAGER) {
      const oldest_agency = F.getOldestAgency(this.state.agencies);

      start_date = dateFilterAMDashbboard.datemodified.start_date || oldest_agency.start_date
        ? moment(oldest_agency.start_date).format("YYYY-MM-DD")
        : "2010-01-01";

      end_date = dateFilterAMDashbboard.datemodified.end_date || moment().format("YYYY-MM-DD");
    } else {
      const defaultRange = F.getDefaultDateRange();
      start_date = dateFilterAMDashbboard.datemodified.start_date || defaultRange.start_date;
      end_date = dateFilterAMDashbboard.datemodified.end_date || defaultRange.end_date;
    }

    localStorage.removeItem("agGridColumnState");

    this.setState({ search: "", searchFilter: "" });
    if (this.state.user.user_type !== SUPER_ADMIN) {
      this.searchChange("");
    }

    if (this.state.columnApi) {
      this.state.columnApi.resetColumnState();
      this.state.columnApi.resetColumnGroupState();
    }

    this.resetHandlers.forEach((reset) => reset());

    if (this.state.user.user_type === SUPER_ADMIN) {
      const selectedCarriers = globalFilter.selectedCarriers || [];
      const selectedAgencyState = globalFilter.selectedAgencyState || [];
      const selectedAgencies =
        globalFilter.selectedAgencies && globalFilter.selectedAgencies.length > 0
          ? globalFilter.selectedAgencies
          : (globalFilter.agency_id ? [globalFilter.agency_id] : []);

      useBoundStore.getState().setFsFilters({
        field: "",
        direction: "",
        selectedRole: "",
        selectedAgency: "",
        searchText: "",
        filter_by_column_name: {},
      });

      this.applyGlobalGridAgencyFilters({
        selectedCarriers,
        selectedAgencyState,
        selectedAgencies,
        agenciesList: this.state.globalGridAgencies,
        shouldLoad: true,
      });
      return;
    }

    //commented due to new date filter implementation
    // let start_date = moment(("2010-01-01")).format("YYYY-MM-DD");
    // let end_date = moment(("2050-01-01")).format("YYYY-MM-DD");

    this.setState({ selectedAgency: "" });
    this.setState({ start_date, end_date }, () => {
      this.loadConditionalData();
    });
  };

  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
      columnApi: params.columnApi,
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  };

  saveState = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  };

  getAppointmentDateSortField = (type_of_call = this.state.type_of_call_selected) => (
    type_of_call === REVIEW ? "rs_appointment_date" : "von_appointment_date"
  );

  getAppointmentSortField = (field, type_of_call = this.state.type_of_call_selected) => {
    if (field === "calendar_time") {
      return this.getAppointmentDateSortField(type_of_call);
    }

    return field;
  };

  handleAppointmentSort = (field, direction = DESC) => {
    const type_of_call = this.state.type_of_call_selected;
    const sortDirection = direction || DESC;
    const sort_by_name = JSON.stringify({
      field: this.getAppointmentSortField(field, type_of_call),
      direction: sortDirection,
    });

    if (type_of_call === REVIEW) {
      window.localStorage.ea_review_sorting_direction = sortDirection;
    } else {
      window.localStorage.ea_virtual_sorting_direction = sortDirection;
    }

    this.setState({ loading: true }, () => {
      this.fetchDataForAM({
        page: 1,
        type_of_call,
        sort_by_name,
        filters: this.state.statusFilters,
      });
    });
  };

  handleExportExcel = () => {
    this.fetchDataForAM({ isExport: true });
  };

  selectGlobalGridAgencies = (selectedAgencies) => {
    this.applyGlobalGridAgencyFilters({
      selectedAgencies,
      shouldLoad: true,
    });
  };

  searchGlobalGridAgencies = (value) => {
    if (!value) {
      this.setState({
        globalGridAgencyOptions: this.getInitialGlobalAgencyOptions(
          this.state.globalGridFilteredAgencyResults,
          this.state.gridSelectedAgencies,
        ),
      });
      return;
    }

    const lower = value.toLowerCase();
    const filtered = this.state.globalGridFilteredAgencyResults.filter((agency) =>
      (agency.name || `Agency #${agency.id}`).toLowerCase().includes(lower),
    );
    this.setState({ globalGridAgencyOptions: filtered });
  };

  renderGlobalGridFilters = () => {
    if (this.state.user.user_type !== SUPER_ADMIN) return null;

    const filterSelectStyle = {
      minWidth: 170,
      maxWidth: 220,
      fontSize: "12px",
    };
    const {
      gridSelectedCarriers,
      gridSelectedAgencyState,
      gridSelectedAgencies,
      globalGridAgencyOptions,
    } = this.state;

    return (
      <div className="vaa-global-grid-filters">
        <Select
          mode="multiple"
          placeholder="Select Carrier"
          getPopupContainer={(trigger) => {
            return trigger.parentElement;
          }}
          maxTagCount={1}
          maxTagTextLength={16}
          maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
          allowClear
          showSearch
          className="custom-select agency-select"
          style={filterSelectStyle}
          value={gridSelectedCarriers}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().includes(input.toLowerCase())
          }
          onChange={(value) => {
            this.applyGlobalGridAgencyFilters({
              selectedCarriers: value,
              selectedAgencies: [],
            });
          }}
          dropdownRender={(menu) => (
            <div>
              <div
                style={{
                  padding: "8px 12px",
                  cursor: "pointer",
                  borderBottom: "1px solid #e8e8e8",
                  fontWeight: 600,
                }}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  const allIds = F.getCarriers().map((carrier) => carrier.id);
                  const isAllSelected = gridSelectedCarriers.length === allIds.length;
                  this.applyGlobalGridAgencyFilters({
                    selectedCarriers: isAllSelected ? [] : allIds,
                    selectedAgencies: [],
                  });
                }}
              >
                <Checkbox
                  checked={gridSelectedCarriers.length === F.getCarriers().length}
                  indeterminate={
                    gridSelectedCarriers.length > 0 &&
                    gridSelectedCarriers.length < F.getCarriers().length
                  }
                >
                  Select All
                </Checkbox>
              </div>
              {menu}
            </div>
          )}
        >
          {F.getCarriers().map((carrier) => (
            <Option key={carrier.id} value={carrier.id}>
              {carrier.name}
            </Option>
          ))}
        </Select>

        <Select
          mode="multiple"
          placeholder="Select Agency Status"
          getPopupContainer={(trigger) => {
            return trigger.parentElement;
          }}
          maxTagCount={1}
          maxTagTextLength={16}
          maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
          allowClear
          showSearch
          className="custom-select agency-select"
          style={{ ...filterSelectStyle, minWidth: 175 }}
          value={gridSelectedAgencyState.map(String)}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().includes(input.toLowerCase())
          }
          onChange={(value) => {
            this.applyGlobalGridAgencyFilters({
              selectedAgencyState: value,
              selectedAgencies: [],
            });
          }}
          dropdownRender={(menu) => (
            <div>
              <div
                style={{
                  padding: "8px 12px",
                  cursor: "pointer",
                  borderBottom: "1px solid #e8e8e8",
                  fontWeight: 600,
                }}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  const allIds = F.getAgenciesState().map((agencyState) =>
                    String(agencyState.id),
                  );
                  const isAllSelected = gridSelectedAgencyState.length === allIds.length;
                  this.applyGlobalGridAgencyFilters({
                    selectedAgencyState: isAllSelected ? [] : allIds,
                    selectedAgencies: [],
                  });
                }}
              >
                <Checkbox
                  checked={gridSelectedAgencyState.length === F.getAgenciesState().length}
                  indeterminate={
                    gridSelectedAgencyState.length > 0 &&
                    gridSelectedAgencyState.length < F.getAgenciesState().length
                  }
                >
                  Select All
                </Checkbox>
              </div>
              {menu}
            </div>
          )}
        >
          {F.getAgenciesState().map((agencyState) => (
            <Option key={String(agencyState.id)} value={String(agencyState.id)}>
              {agencyState.name}
            </Option>
          ))}
        </Select>

        <Select
          mode="multiple"
          placeholder="Select Agency"
          getPopupContainer={(trigger) => {
            return trigger.parentElement;
          }}
          maxTagCount={1}
          maxTagTextLength={16}
          maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
          allowClear
          showSearch
          filterOption={false}
          className="custom-select agency-select"
          style={{ ...filterSelectStyle, minWidth: 220 }}
          value={gridSelectedAgencies}
          onSearch={this.searchGlobalGridAgencies}
          onChange={this.selectGlobalGridAgencies}
          dropdownRender={(menu) => (
            <div>
              <div
                style={{
                  padding: "8px 12px",
                  cursor: "pointer",
                  borderBottom: "1px solid #e8e8e8",
                  fontWeight: 600,
                }}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  const allIds = globalGridAgencyOptions.map((agency) => agency.id);
                  const isAllSelected =
                    gridSelectedAgencies.length === allIds.length && allIds.length > 0;
                  this.selectGlobalGridAgencies(isAllSelected ? [] : allIds);
                }}
              >
                <Checkbox
                  checked={
                    gridSelectedAgencies.length === globalGridAgencyOptions.length &&
                    globalGridAgencyOptions.length > 0
                  }
                  indeterminate={
                    gridSelectedAgencies.length > 0 &&
                    gridSelectedAgencies.length < globalGridAgencyOptions.length
                  }
                >
                  Select All
                </Checkbox>
              </div>
              {menu}
            </div>
          )}
        >
          {globalGridAgencyOptions.map((agencyOption) => (
            <Option key={agencyOption.id} value={agencyOption.id}>
              {agencyOption.name || `Agency #${agencyOption.id}`}
            </Option>
          ))}
        </Select>
      </div>
    );
  };

  renderViewAppointmentDatePicker = (start_date, end_date, years, months) => (
    <DatePicker.RangePicker
      className="border-radius-25"
      dropdownClassName="custom-range-picker"
      open={this.state.open}
      onOpenChange={(status) => {
        if (!status) return;
        this.setState({ open: true });
      }}
      style={{ width: "100%" }}
      value={[
        start_date ? moment(start_date) : null,
        end_date ? moment(end_date) : null,
      ]}
      format={dateFormat}
      allowClear={false}
      onChange={(dates) => this.onRangeChange(dates)}
      renderExtraFooter={() => {
        const start = this.state.start_date
          ? moment(this.state.start_date)
          : moment();

        const end = this.state.end_date
          ? moment(this.state.end_date)
          : moment();

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 8,
              width: "100%",
              boxSizing: "border-box",
              minWidth: 0,
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
              <div style={{ fontSize: 12, marginBottom: "-7px" }}>Start</div>
              <div style={{ display: "flex", gap: 6, marginBottom: "15px" }}>
                <Select
                  showSearch
                  value={start.month()}
                  className="vaa-date-footer-select month"
                  style={{ width: 125 }}
                  onChange={(month) => {
                    const newDate = start.clone().month(month);
                    this.setState({ start_date: newDate.format("YYYY-MM-DD") });
                  }}
                  filterOption={(input, option) =>
                    option.props.children &&
                    option.props.children
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {months.map((m, i) => (
                    <Option key={i} value={i}>
                      {m}
                    </Option>
                  ))}
                </Select>

                <Select
                  showSearch
                  value={start.year()}
                  className="vaa-date-footer-select year"
                  style={{ width: 95 }}
                  onChange={(year) => {
                    const newDate = start.clone().year(year);
                    this.setState({ start_date: newDate.format("YYYY-MM-DD") });
                  }}
                  filterOption={(input, option) =>
                    option.props.children &&
                    option.props.children
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {years.map((y) => (
                    <Option key={y} value={y}>
                      {y}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
              <div style={{ fontSize: 12, marginBottom: "-7px" }}>End</div>
              <div style={{ display: "flex", gap: 6, marginBottom: "15px" }}>
                <Select
                  showSearch
                  value={end.month()}
                  className="vaa-date-footer-select month"
                  style={{ width: 125 }}
                  onChange={(month) => {
                    const newDate = end.clone().month(month);
                    this.setState({ end_date: newDate.format("YYYY-MM-DD") });
                  }}
                  filterOption={(input, option) =>
                    option.props.children &&
                    option.props.children
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {months.map((m, i) => (
                    <Option key={i} value={i}>
                      {m}
                    </Option>
                  ))}
                </Select>

                <Select
                  showSearch
                  value={end.year()}
                  className="vaa-date-footer-select year"
                  style={{ width: 95 }}
                  onChange={(year) => {
                    const newDate = end.clone().year(year);
                    this.setState({ end_date: newDate.format("YYYY-MM-DD") });
                  }}
                  filterOption={(input, option) =>
                    option.props.children &&
                    option.props.children
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {years.map((y) => (
                    <Option key={y} value={y}>
                      {y}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>

            <div
              className="vaa-date-footer-today"
              style={{
                alignSelf: "center",
                cursor: "pointer",
                color: "#1890ff",
                marginTop: "10px",
              }}
              onClick={() => {
                const today = moment();
                this.onRangeChange([today, today]);
                this.setState({ open: false });
              }}
            >
              Today
            </div>

            <div style={{ alignSelf: "center" }}>
              <Button
                type="primary"
                className="borderRadius-28 bg-164897 vaa-date-footer-apply"
                style={{ marginTop: "15px", minWidth: 86 }}
                onClick={() => {
                  const { start_date, end_date } = this.state;
                  this.onRangeChange([start_date, end_date]);
                  this.setState({ open: false });
                }}
              >
                <Translate text={"Apply"}></Translate>
              </Button>
            </div>
          </div>
        );
      }}
    />
  );

  render() {
    const { dashboard, user, period, filter_lsp } = this.props;
    let { associations, islsp } = this.props;

    associations = associations.filter((item) => item.id !== user.id);
    // console.log("ASSOCIATIONS", associations);

    const {
      bfiles,
      bfile,
      loading,
      filteredInfo,
      start_date,
      end_date,
    } = this.state;

    const handleTableChange = (_, filters, __) => {
      this.setState({ statusFilters: filters.status });
    };

    const years = Array.from({ length: 41 }, (_, i) => 2010 + i);
    const months = moment.months();
    const isInlineAppointmentUser = [AGENCY_MANAGER, LSP, EA, SUPER_ADMIN].includes(user.user_type);

    const selectAgency = (value) => {
      let startDate = start_date;
      let endDate = end_date;
      if (value && !this.props.isGlobalDashboard) {
        const selected = this.state.agencies.find((a) => a.agency_id === value);
        if (selected) {
          startDate = moment(selected.start_date).format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
        }
      }
      const sort_by_name = JSON.stringify({
        field: "first_name",
        direction: DESC,
      });
      value = value == "" ? ALL_AGENCIES : value;

      //commented due to new date picker implementation
      // this.setState({ selectedAgency: value, loading: true });
      // this.fetchDataForAM({ agency_id: value, sort_by_name });

      //added due to new date filter implementation
      this.setState(
        {
          selectedAgency: value,
          start_date: startDate,
          end_date: endDate,
          loading: true,
        },
        () => {
          this.fetchDataForAM({
            agency_id: value,
            sort_by_name,
            start_date: startDate,
            end_date: endDate,
          });
        },
      );
    };

    let direction = DESC;

    if (this.state.type_of_call_selected === "Review") {
      if ("ea_review_sorting_direction" in window.localStorage) {
        direction = window.localStorage.ea_review_sorting_direction;
      }
    } else {
      if ("ea_virtual_sorting_direction" in window.localStorage) {
        direction = window.localStorage.ea_virtual_sorting_direction;
      }
    }

    const handleFilter = (field, value) => {
      this.fetchDataForAM({ filters: value });
    };

    const handleFilterResetHandler = (resetFn) => {
      this.resetHandlers.push(resetFn);
    };

    // Convert AntD columns to Ag Grid columnDefs
    const columnDefs = [
      {
        headerClass: "custom-ag-header",
        headerName: "Customer Name",
        field: "customer_name",
        minWidth: 250,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ["Customer Name"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "customer_name",
        }),
        filter: "agTextColumnFilter",
        cellRendererFramework: (params) => params.value,
      },
      {
        headerClass: "custom-ag-header",
        headerName: "Calendar Time",
        field: "calendar_time",
        minWidth: 250,
        flex: 1,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ["Calendar Time"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "calendar_time",
          sortOrder: direction,
          handleSort: this.handleAppointmentSort,
        }),
        filter: "agTextColumnFilter",
        cellRendererFramework: (params) => <div>{params.value}</div>,
      },
      {
        headerClass: "custom-ag-header",
        headerName: "Agency Staff",
        field: "lsp",
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ["Agency Staff"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "lsp",
        }),
        filter: "agTextColumnFilter",
        cellRendererFramework: (params) => <div>{params.value}</div>,
      },
      {
        headerClass: "custom-ag-header",
        headerName: "Status",
        field: "status",
        sortable: false,
        filter: false,
        minWidth: 200,
        flex: 1,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ["Status"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "status",
          // handleFilter: (field, selected) => {
          //   const next = Array.isArray(selected) && selected.length > 0
          //     ? selected
          //     : ["Complete", "Not Complete"];
          //   this.setState({ statusFilters: next });
          // },
          showPopOver: true,
          handleFilter,
          inputType: "multiCheckbox",
          options: F.getCompletedNonCompletedStatus(),
          handleFilterResetHandler,
        }),
        cellRendererFramework: (params) => (
          <div>
            <span
              className="dot"
              style={{ backgroundColor: params.data.borderBottomColor }}
            ></span>{" "}
            <span>{params.value}</span>
          </div>
        ),
      },
    ];
    if (user.user_type != AGENCY_MANAGER && user.user_type != SUPER_ADMIN) {
      columnDefs.push({
        headerClass: "custom-ag-header",
        headerName: "Reschedule",
        field: "Reschedule",
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ["Reschedule"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "Reschedule",
        }),
        filter: false,
        cellRendererFramework: (params) => params.value,
      });
      if (
        (this.state.type_of_call_selected === REVIEW && this.props.review) ||
        this.props.is_lead == 1 ||
        (["Prospect", "FollowUp"].includes(this.state.type_of_call_selected) &&
          this.props.vonboard)
      ) {
        columnDefs.push({
          headerClass: "custom-ag-header",
          headerName: "Mark as Complete",
          field: "mark_as_complete",
          minWidth: 250,
          flex: 1,
          sortable: false,
          headerComponent: CustomHeader,
          headerComponentParams: (params) => ({
            headers: ["Mark as Complete"],
            colDef: params.column.getColDef(),
            columnApi: params.columnApi,
            field: "mark_as_complete",
          }),
          filter: false,
          cellRendererFramework: (params) => params.value,
        });
      }
    }

    // if (bfiles.length > 0) {
    //   F.log("NOOR => bfiles Data =>", JSON.stringify(bfiles));
    // }

    let data = [];
    if (bfiles[this.state.type_of_call_selected]["data"].length !== 0) {
      for (
        let i = 0;
        i < bfiles[this.state.type_of_call_selected]["data"].length;
        i++
      ) {
        const bfile = bfiles[this.state.type_of_call_selected]["data"][i];

        let isComplete = null;

        if (this.state.type_of_call_selected === "Review") {
          // isComplete = bfile.need_attention ||
          // bfile.onboarding_id ||
          // bfile.financial_id ||
          // bfile.is_onboarded ||
          // bfile.archive ||
          // bfile.bfile_folow_up_completed ||
          isComplete = bfile.bfile_review_completed;
        } else {
          isComplete = F.isVonBorderBFileCompleted(bfile);
        }

        const type = this.state.type_of_call_selected;

        const mark_as_complete_visible =
          bfile.agency_id &&
          !isComplete &&
          ((type === REVIEW && this.props.review) ||
            ((type === PROSPECT || type === FOLLOWUP) && this.props.vonboard) ||
            this.props.is_lead);

        // const mark_as_complete_visible = (bfile.agency_id &&
        //   !isComplete) &&
        //   (['Review'].includes(this.state.type_of_call_selected)
        //     ? this.props.review ? true : false
        //     : ['Prospect', 'FollowUp'].includes(this.state.type_of_call_selected)
        //       ? this.props.vonboard ? true : false
        //       : false);
        const status = isComplete ? "Complete" : "Not Complete";
        // F.log("first", bfile.rs_appointment_date, bfile.first_name);
        // F.log("first", moment(new Date(bfile.rs_appointment_date)).utc());
        let borderBottomColor = "#2dcc70";
        if (!isComplete) {
          // compare appointment time with current time => http://jsfiddle.net/e34y0p1v/
          var currentDateTime = moment(new Date()).utc(); // 09
          var appointmentDate =
            this.state.type_of_call_selected === "Review"
              ? moment(new Date(bfile.rs_appointment_date)).utc()
              : moment(
                new Date(F.getVonBorderAppointmentDateFromBFile(bfile)),
              ).utc(); // 08
          var diffInHours = appointmentDate.diff(currentDateTime, "hours");

          // TRUE => UPCOMING , FALSE => TIME EXCEEDED
          const isUpcomingAppointment = diffInHours >= -12;

          if (isUpcomingAppointment) borderBottomColor = "#f1c40f";
          else borderBottomColor = "#e74c3d";
        }

        let Reschedule = !isComplete ? (
          <Button
            className="borderRadius-28"
            // style={{ marginLeft: 10 }}
            onClick={() => {
              this.rescheduleAppointment(bfile);
            }}
            danger
          >
            <Translate text={`Reschedule`} />
          </Button>
        ) : (
          <span />
        );

        let mark_as_complete = mark_as_complete_visible ? (
          <Button
            className="borderRadius-28"
            // style={{ marginLeft: 10 }}
            onClick={() => {
              this.setState({ loading: true });
              this.mark_as_complete(bfile);
            }}
            danger
          >
            <Translate text={`Mark as Complete`} />
          </Button>
        ) : (
          <span />
        );

        // 2022-09-01T10:30:48-04:00
        const calendar_time =
          this.state.type_of_call_selected === "Review"
            ? moment(bfile.rs_appointment_date).format("MM/DD/YYYY hh:mmA")
            : moment(F.getVonBorderAppointmentDateFromBFile(bfile)).format(
              "MM/DD/YYYY hh:mmA",
            );
        // const calendar_time = bfile.rs_appointment_date;

        if (this.state.statusFilters.includes(status)) {
          data.push({
            id: i,
            customer_name: (
              // <Tooltip placement="left" title={bfile.first_name + " " + bfile.last_name}>
              <Link to={"/customer/" + bfile.id}>
                {bfile.first_name + " " + bfile.last_name}
              </Link>
              //  </Tooltip>
            ),
            // appointment_history: (
            //   <Button onClick={() => this.setState({ isViewAppointmentLogs: true })} > <Translate text={`History Logs`} /></ Button>
            // ),
            calendar_time,
            lsp: bfile.user.first_name + " " + bfile.user.last_name,
            status,
            Reschedule,
            isComplete,
            borderBottomColor,
            mark_as_complete,
          });
        }
      }
    }

    let date_url = "";

    if (this.state.type_of_call_selected === "Review") {
      if (period === "all_bfiles") {
        date_url = "?all_bfiles";
      }

      let totalPercentage = 0;
      if (
        dashboard.agency_stats != null &&
        dashboard.agency_stats.completed_percentage != null
      ) {
        totalPercentage = dashboard.agency_stats.completed_percentage;
      }
    }

    return (
      <React.Fragment>
        <Modal
          maskClosable={false}
          visible={this.props.isViewAppoinmentModal}
          onCancel={this.props.cancelViewAppoinmentModal}
          destroyOnClose={true}
          footer={null}
          width={1200}
        >
          <div>
            <Row className="header-vaa">
              <Col style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Row>
                  <Icon
                    type="appstore"
                    style={{ marginRight: 10, color: "#1890ff" }}
                  />
                  <b>
                    <Translate text={`${this.props.appointment_name}`} />
                  </b>
                </Row>
              </Col>
              <Col
                style={{
                  margin: 10,
                  display: "flex",
                  alignItems: "flex-end",
                  flexDirection: "column",
                }}
              >
                <Row gutter={8}>
                  <Col style={{ display: "flex", gap: "12px" }}>
                    {user.user_type !== SUPER_ADMIN && (
                      <Button
                        type="primary"
                        className="refreshBtnCss"
                        onClick={this.handleExportExcel}
                      >
                        <Icon type="upload" style={{ marginRight: "10px" }} />
                        <Translate text={EXPORT_DATA} />
                      </Button>
                    )}

                    {/* <Button
                      onClick={() => this.setState({ isViewAppointmentLogs: true })}
                    >
                      <Translate text={"View Appointment History"}></Translate></Button> */}
                    <Link
                      to={`/appointment-history?isFromAllViewAppointment=${this.state.isFromAllViewAppointment}${this.props.isGlobalDashboard ? "&global_dashboard=true" : ""}`}
                    >
                      <Button
                        type="primary"
                        className="borderRadius-28 bg-164897"
                      >
                        <Translate
                          text={"View Appointment History"}
                        ></Translate>
                      </Button>
                    </Link>
                  </Col>
                  {/* <Col>
                  <Button className={state.period === 'all_bfiles' && 'active'} onClick={() => this.props.changePeriod({ target: { value: "all_bfiles" } })}>All B-files</Button>
                </Col> */}
                </Row>
                {false && isInlineAppointmentUser && (
                  <Row className="vaa-inline-toolbar">
                    <Col className="vaa-inline-left-controls">
                      <Translator>
                        {({ translate }) => (
                          <Input
                            className="layoutsearch input-ellipse"
                            prefix={
                              <Icon type="search" style={{ color: "gray" }} />
                            }
                            value={this.state.search}
                            placeholder={translate({ text: `Search File` })}
                            style={{ width: "220px" }}
                            allowClear
                            onChange={(e) => {
                              const value = e.target.value;
                              this.setState({ search: value });

                              if (!value) {
                                this.searchChange("");
                              }
                            }}
                            onPressEnter={(e) => {
                              this.searchChange(e.target.value);
                            }}
                          />
                        )}
                      </Translator>

                      {(user.user_type == EA || user.user_type == LSP) && (
                        <Select
                          className="dropDown custom-select"
                          style={{ width: 220 }}
                          value={
                            this.state.user_t && this.state.user_t !== ""
                              ? this.state.user_t
                              : "all"
                          }
                          placeholder="Select Staff"
                          allowClear
                          onChange={(value) => {
                            this.setState({ user_t: value }, () =>
                              this.loadConditionalData(),
                            );
                          }}
                        >
                          <Select.Option value="all">All</Select.Option>

                          {this.state.agencyStaffList.map((e) => (
                            <Select.Option key={e.id} value={String(e.id)}>
                              {e.name}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Col>

                    <Col className="vaa-inline-right-controls">
                      {user.user_type === AGENCY_MANAGER && (
                        <Select
                          allowClear
                          showSearch
                          className="custom-select"
                          style={{
                            fontSize: "12px",
                            backgroundColor: "white",
                            borderRadius: "20px",
                            width: "200px",
                          }}
                          placeholder="Search By Agency"
                          optionFilterProp="children"
                          onChange={selectAgency}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          value={this.state.selectedAgency}
                        >
                          <Option value="" style={{ fontSize: "12px" }}>
                            All Agencies
                          </Option>
                          {this.state.agencies.map((opt) => (
                            <Option
                              key={opt.agency_id}
                              value={opt.agency_id}
                              style={{ fontSize: "12px" }}
                            >
                              {opt.agency_name}
                            </Option>
                          ))}
                        </Select>
                      )}

                      <div className="date-picker-col" style={{ width: 270 }}>
                        <div
                          className="datepicker-label"
                          style={{ fontSize: "x-small" }}
                        >
                          Select Date Range
                        </div>
                        {this.renderViewAppointmentDatePicker(start_date, end_date, years, months)}
                      </div>

                      <Button
                        onClick={this.refreshStats}
                        type="primary"
                        className="refreshBtnCss"
                        style={{ marginTop: "20px" }}
                      >
                        <Icon type="reload" style={{ fontSize: "20px" }} />
                      </Button>
                    </Col>
                  </Row>
                )}
                {user.user_type === SUPER_ADMIN && !isInlineAppointmentUser && (
                <Row
                  gutter={12}
                  className="datepicker"
                  style={{
                    marginTop: 15,
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  {user.user_type === AGENCY_MANAGER && (
                    <Col>
                      <div className="datepicker-label"></div>
                      <Select
                        allowClear
                        showSearch
                        className="custom-select"
                        style={{
                          fontSize: "12px",
                          backgroundColor: "white",
                          borderRadius: "20px",
                          width: "200px",
                          marginTop: "15px",
                        }}
                        placeholder="Search By Agency"
                        optionFilterProp="children"
                        onChange={selectAgency}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        value={this.state.selectedAgency}
                      >
                        <Option value="" style={{ fontSize: "12px" }}>
                          All Agencies
                        </Option>
                        {this.state.agencies.map((opt) => (
                          <Option
                            key={opt.agency_id}
                            value={opt.agency_id}
                            style={{ fontSize: "12px" }}
                          >
                            {opt.agency_name}
                          </Option>
                        ))}
                      </Select>
                    </Col>
                  )}

                  <Col className="date-picker-col" style={{ width: 270 }}>
                    <div
                      className="datepicker-label"
                      style={{ fontSize: "x-small" }}
                    >
                      Select Date Range
                    </div>
                    <DatePicker.RangePicker
                      className="border-radius-25"
                      dropdownClassName="custom-range-picker"
                      open={this.state.open}
                      onOpenChange={(status) => {
                        if (!status) return;
                        this.setState({ open: true });
                      }}
                      style={{ width: "100%" }}
                      value={[
                        start_date ? moment(start_date) : null,
                        end_date ? moment(end_date) : null,
                      ]}
                      format={dateFormat}
                      allowClear={false}
                      onChange={(dates) => this.onRangeChange(dates)}
                      renderExtraFooter={() => {
                        const start = this.state.start_date
                          ? moment(this.state.start_date)
                          : moment();

                        const end = this.state.end_date
                          ? moment(this.state.end_date)
                          : moment();

                        return (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: 8,
                              width: "100%",
                              boxSizing: "border-box",
                              minWidth: 0,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 0,
                              }}
                            >
                              <div style={{ fontSize: 12, marginBottom: "-7px" }}>
                                Start
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: 6,
                                  marginBottom: "15px",
                                }}
                              >
                                <Select
                                  showSearch
                                  value={start.month()}
                                  className="vaa-date-footer-select month"
                                  style={{ width: 125 }}
                                  onChange={(month) => {
                                    const newDate = start.clone().month(month);
                                    this.setState({
                                      start_date: newDate.format("YYYY-MM-DD"),
                                    });
                                  }}
                                  filterOption={(input, option) =>
                                    option.props.children &&
                                    option.props.children
                                      .toString()
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {months.map((m, i) => (
                                    <Option key={i} value={i}>
                                      {m}
                                    </Option>
                                  ))}
                                </Select>

                                <Select
                                  showSearch
                                  value={start.year()}
                                  className="vaa-date-footer-select year"
                                  style={{ width: 95 }}
                                  onChange={(year) => {
                                    const newDate = start.clone().year(year);
                                    this.setState({
                                      start_date: newDate.format("YYYY-MM-DD"),
                                    });
                                  }}
                                  filterOption={(input, option) =>
                                    option.props.children &&
                                    option.props.children
                                      .toString()
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {years.map((y) => (
                                    <Option key={y} value={y}>
                                      {y}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 0,
                              }}
                            >
                              <div style={{ fontSize: 12, marginBottom: "-7px" }}>
                                End
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: 6,
                                  marginBottom: "15px",
                                }}
                              >
                                <Select
                                  showSearch
                                  value={end.month()}
                                  className="vaa-date-footer-select month"
                                  style={{ width: 125 }}
                                  onChange={(month) => {
                                    const newDate = end.clone().month(month);
                                    this.setState({
                                      end_date: newDate.format("YYYY-MM-DD"),
                                    });
                                  }}
                                  filterOption={(input, option) =>
                                    option.props.children &&
                                    option.props.children
                                      .toString()
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {months.map((m, i) => (
                                    <Option key={i} value={i}>
                                      {m}
                                    </Option>
                                  ))}
                                </Select>

                                <Select
                                  showSearch
                                  value={end.year()}
                                  className="vaa-date-footer-select year"
                                  style={{ width: 95 }}
                                  onChange={(year) => {
                                    const newDate = end.clone().year(year);
                                    this.setState({
                                      end_date: newDate.format("YYYY-MM-DD"),
                                    });
                                  }}
                                  filterOption={(input, option) =>
                                    option.props.children &&
                                    option.props.children
                                      .toString()
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {years.map((y) => (
                                    <Option key={y} value={y}>
                                      {y}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                            </div>

                            <div
                              className="vaa-date-footer-today"
                              style={{
                                alignSelf: "center",
                                cursor: "pointer",
                                color: "#1890ff",
                                marginTop: "10px",
                              }}
                              onClick={() => {
                                const today = moment();
                                this.onRangeChange([today, today]);
                                this.setState({ open: false });
                              }}
                            >
                              Today
                            </div>

                            <div style={{ alignSelf: "center" }}>
                              <Button
                                type="primary"
                                className="borderRadius-28 bg-164897 vaa-date-footer-apply"
                                style={{ marginTop: "15px", minWidth: 86 }}
                                onClick={() => {
                                  const { start_date, end_date } = this.state;
                                  this.onRangeChange([start_date, end_date]);
                                  this.setState({ open: false });
                                }}
                              >
                                <Translate text={"Apply"}></Translate>
                              </Button>
                            </div>
                          </div>
                        );
                      }}
                    />
                  </Col>
                  <Col>
                    <Button
                      onClick={this.refreshStats}
                      type="primary"
                      className="refreshBtnCss"
                      style={{
                        marginTop: "20px",
                      }}
                    >
                      <Icon type="reload" style={{ fontSize: "20px" }} />
                    </Button>
                  </Col>
                </Row>
                )}
              </Col>
            </Row>

            <Row
              className={`vaa-filter-row ${
                user.user_type === SUPER_ADMIN ? "vaa-super-admin-filter-row" : ""
              }`}
              gutter={10}
              align="middle"
            >
              <Col className="vaa-search-col">
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                  }}
                  gutter={10}
                  align="middle"
                >
                  <Col flex="auto">
                    <Translator>
                      {({ translate }) => (
                        <Input
                          className="layoutsearch input-ellipse"
                          prefix={
                            <Icon type="search" style={{ color: "gray" }} />
                          }
                          value={this.state.search}
                          placeholder={translate({ text: `Search Files` })}
                          style={{ width: "100%" }}
                          allowClear
                          onChange={(e) => {
                            const value = e.target.value;
                            this.setState({ search: value });

                            if (!value) {
                              this.searchChange("");
                            }
                          }}
                          onPressEnter={(e) => {
                            this.searchChange(e.target.value);
                          }}
                        />
                      )}
                    </Translator>
                  </Col>

                  <Col>
                    {(user.user_type == EA || user.user_type == LSP) && (
                      <Select
                        className="dropDown custom-select"
                        style={{ width: "220px !important" }}
                        value={
                          this.state.user_t && this.state.user_t !== ""
                            ? this.state.user_t
                            : "all"
                        }
                        // value={this.state.user_t !== undefined ? this.state.user_t : undefined}
                        placeholder="Select Staff"
                        allowClear
                        onChange={(value) => {
                          this.setState({ user_t: value }, () =>
                            this.loadConditionalData(),
                          );
                        }}
                      >
                        <Select.Option value="all">All</Select.Option>

                        {this.state.agencyStaffList.map((e) => (
                          <Select.Option key={e.id} value={String(e.id)}>
                            {e.name}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                    {user.user_type === AGENCY_MANAGER && (
                      <Select
                        allowClear
                        showSearch
                        className="custom-select"
                        style={{
                          fontSize: "12px",
                          backgroundColor: "white",
                          borderRadius: "20px",
                          width: "200px",
                        }}
                        placeholder="Search By Agency"
                        optionFilterProp="children"
                        onChange={selectAgency}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        value={this.state.selectedAgency}
                      >
                        <Option value="" style={{ fontSize: "12px" }}>
                          All Agencies
                        </Option>
                        {this.state.agencies.map((opt) => (
                          <Option
                            key={opt.agency_id}
                            value={opt.agency_id}
                            style={{ fontSize: "12px" }}
                          >
                            {opt.agency_name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Col>
                </Row>
              </Col>
              {user.user_type === SUPER_ADMIN && (
                <Col className="vaa-global-filter-col">
                  {this.renderGlobalGridFilters()}
                </Col>
              )}
              {isInlineAppointmentUser && (
                <Col className="vaa-inline-date-col">
                  <div className="date-picker-col" style={{ width: 270 }}>
                    <div
                      className="datepicker-label"
                      style={{ fontSize: "x-small" }}
                    >
                      Select Date Range
                    </div>
                    {this.renderViewAppointmentDatePicker(start_date, end_date, years, months)}
                  </div>
                  <Button
                    onClick={this.refreshStats}
                    type="primary"
                    className="refreshBtnCss"
                    style={{ marginTop: "20px" }}
                  >
                    <Icon type="reload" style={{ fontSize: "20px" }} />
                  </Button>
                </Col>
              )}
            </Row>
            {this.state.isFromAllViewAppointment && (
              <Row>
                <ButtonGroup className="button_selection_group bfile">
                  {/* Show "Review" button only if this.props.review === 1 */}
                  {this.props.review === 1 && (
                    <Button
                      className={
                        this.state.type_of_call_selected === "Review"
                          ? "Review active"
                          : "inactive"
                      }
                      onClick={() => {
                        this.setState(
                          {
                            type_of_call_selected: "Review",
                            search: "",
                            searchFilter: "",
                          },
                          () => {
                            this.loadBFiles(1, REVIEW);
                          },
                        );
                      }}
                    >
                      Review Appointments
                    </Button>
                  )}

                  {/* Show "Leads" and "Opportunities" buttons only if this.props.vonboard === 1 */}
                  {
                    // this.props.vonboard === 1 && (
                    <React.Fragment>
                      {this.props.is_lead === 1 && (
                        <Button
                          className={
                            this.state.type_of_call_selected === "Prospect"
                              ? "leads active"
                              : "inactive"
                          }
                          onClick={() =>
                            this.setState({
                              type_of_call_selected: "Prospect",
                              search: "",
                            })
                          }
                        >
                          Lead Appointments
                        </Button>
                      )}

                      {this.props.is_opportunity === 1 && (
                        <Button
                          className={
                            this.state.type_of_call_selected === "FollowUp"
                              ? "Opportunities active"
                              : "inactive"
                          }
                          onClick={() =>
                            this.setState({
                              type_of_call_selected: "FollowUp",
                              search: "",
                            })
                          }
                        >
                          Opportunity Appointments
                        </Button>
                      )}
                    </React.Fragment>
                    // )
                  }
                </ButtonGroup>
              </Row>
            )}

            <div>
              <Spin indicator={antIcon} spinning={loading}>
                <div style={{ marginBottom: 20 }}>
                  {/* {user.user_type !== "AGENCY_MANAGER" && ( */}
                  <Card bordered={false} className="statsDetails have_extra">
                    <CustomAgGridTable
                      onGridReady={this.onGridReady}
                      onColumnMoved={this.saveState}
                      onSortChanged={this.saveState}
                      onFilterChanged={this.saveState}
                      rowDatas={data || []}
                      columnDefss={columnDefs}
                    />
                    <Pagination
                      current_page={
                        bfiles[this.state.type_of_call_selected].page
                      }
                      total_pages={
                        bfiles[this.state.type_of_call_selected].total_pages
                      }
                      onClick={(page) => {
                        this.setState({ loading: true }, () =>
                          this.loadBFiles(
                            page,
                            this.state.type_of_call_selected,
                          ),
                        );
                      }}
                    />
                  </Card>
                  {/* )} */}
                </div>
              </Spin>
            </div>
          </div>
        </Modal>
        <Modal
          title={<Translate text="Add a Note" />}
          visible={!!this.state.rescheduleTarget}
          onCancel={this.cancelReschedule}
          closable={!this.state.savingReschedule}
          maskClosable={!this.state.savingReschedule}
          keyboard={!this.state.savingReschedule}
          cancelButtonProps={{
            className: 'borderRadius-28',
          }}
          okButtonProps={{
            className: 'borderRadius-28 bg-164897',
            style: {
              color: 'white'
            }
          }}
          footer={[
            <Button key="cancel" onClick={this.cancelReschedule}
              className="borderRadius-28"
              disabled={this.state.savingReschedule}>
              <Translate text="Cancel" />
            </Button>,
            <Button
              key="save"
              type="primary"
              onClick={this.saveReschedule}
              className="borderRadius-28 bg-164897"
              loading={this.state.savingReschedule}
              disabled={!this.state.rescheduleNote.trim() || this.state.savingReschedule}
            >
              <Translate text="Save" />
            </Button>,
          ]}
        >
          <div className="formBox">
            <label htmlFor="reschedule-note">
              <Translate text="Note" />
              <span className="asteriskIcon">*</span>
            </label>
            <Input.TextArea
              className="bad-phone-reason-input"
              id="reschedule-note"
              required
              aria-required="true"
              rows={4}
              placeholder="Add a note for the scheduling team"
              maxLength={250}
              value={this.state.rescheduleNote}
              disabled={this.state.savingReschedule || this.state.rescheduleNoteSaved}
              onChange={(event) => this.setState({ rescheduleNote: event.target.value })}
            />
            <div style={{ marginTop: 4, textAlign: "right", color: "#999" }}>
              {this.state.rescheduleNote.length}/250
            </div>

          </div>
        </Modal>
        {this.state.isViewAppointmentLogs === true && (
          <EaAppointmentLogs
            showModal={this.state.isViewAppointmentLogs}
            isGlobalDashboard={this.props.isGlobalDashboard}
            hideModal={() => {
              this.setState({ isViewAppointmentLogs: false });
            }}
            // state={{ ...this.state }}
            user={this.props.user}
            agency_id={agency_id}
          />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/EA_And_LSP/ViewAllAppointment.js